import { merge } from 'ramda'

import { createReducer } from 'utils/redux'

import * as actions from './actions'

const receiveAssistantAgentSettings = ({ draft, action }) => {
  return merge(draft, action.payload)
}

const reducerActions = {
  [actions.fetchAssistantAgentSettingsSuccess]: receiveAssistantAgentSettings,
  [actions.patchAssistantAgentSettingsSuccess]: receiveAssistantAgentSettings,
}

const assistantReducer = createReducer({}, reducerActions)

export default assistantReducer
